import { useTranslations } from "@ui/providers/useTranslations";
import classNames from "classnames";

import { UiDownloadIcon } from "@jti/brand-icons/ui-download";
import { Button, type ButtonProps, type ButtonSize } from "@jti/core-components/components/Button";

import styles from "./DownloadButton.module.scss";

type DownloadButtonProps = ButtonProps & {
  text?: string;
  href: string;
  customSize?: ButtonSize;
};

export const DownloadButton = ({ text, href, className, customSize, ...props }: DownloadButtonProps) => {
  const { __ } = useTranslations();
  return (
    <Button
      variant="primary"
      size={customSize || "sm"}
      href={href}
      className={classNames(styles.downloadButton, className)}
      {...props}
      iconBefore={UiDownloadIcon}
    >
      {text || __("general.download.button.label")}
    </Button>
  );
};
